import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

export function CenteredCardText({
  text,
  icon,
  action,
}: {
  text: string;
  icon?: ReactNode;
  /** Optional call to action rendered under the text, e.g. a recovery button. */
  action?: ReactNode;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 1,
        color: 'text.secondary',
      }}
    >
      {icon}
      <Typography variant="body2" sx={{ color: 'text.secondary', opacity: 0.4 }}>
        {text}
      </Typography>
      {action}
    </Box>
  );
}
